import React, { FC, ReactNode } from 'react'
import ReactMarkdown from 'react-markdown'

import { FlexContainer } from '@avantstay/backoffice-core'
import { IconGlitter } from '@avantstay/backoffice-vectors'

import { BetaBadge } from '../../BetaBadge'
import { AIBannerTheme } from '../AIElements.types'
import * as S from './AIElements.styles'

export interface AIBannerProps {
  content: string
  bannerTitle?: ReactNode
  isBeta?: boolean
  isPlainText?: boolean
  theme?: AIBannerTheme
  extraActions?: ReactNode
}

export const Banner: FC<AIBannerProps> = ({
  content,
  bannerTitle = 'AI Summary',
  isBeta,
  isPlainText,
  theme = AIBannerTheme.light,
  extraActions,
}) => {
  return (
    <S.Root theme={theme}>
      <S.Title>
        <FlexContainer gap={4} justify="flex-start">
          <IconGlitter />
          {bannerTitle}
          {isBeta ? <BetaBadge /> : null}
        </FlexContainer>

        {extraActions}
      </S.Title>
      <S.Description $isPlainText={isPlainText}>
        {isPlainText ? content : <ReactMarkdown>{content}</ReactMarkdown>}
      </S.Description>
    </S.Root>
  )
}
